import { BaseViewModel } from "@iot-platform/core";
import { SpatialLevelGetAllUseCase } from "@station/domain/usecases/spatial-level-get-all.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationResponsivePageViewmodel extends BaseViewModel {
    @observable
    initialLoading = true;

    constructor(
        @inject(SpatialLevelGetAllUseCase)
        private readonly spatialLevelGetAllUseCase: SpatialLevelGetAllUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    async initViewData(): Promise<void> {
        await this.fetchSpatialLevels();

        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    private async fetchSpatialLevels(): Promise<void> {
        await this.spatialLevelGetAllUseCase.execute();
    }
}
